import React, {useEffect, useState} from 'react';
import { connect } from "react-redux";
import {FormattedMessage, injectIntl} from "react-intl";
import PropTypes from "prop-types";

import {toggleProductNoteEditorVisible} from "../../../actions/selectionFunctions";
import {togglePulseFeatureInfoNote} from "../../../actions/actionFunctions";
import {wizardGroupInterface} from "../../../interfaces/wizardItemInterface";

const AddProductNoteEditor = (props) => {

  const {selectionFeatureInfo, productNoteEditorVisible, intl, toggleProductNoteEditorVisible, activeQuoteIndex,
    pulseFeatureInfoNote, togglePulseFeatureInfoNote, wizardGroup} = props;
  const [noteText, setNoteText] = useState("");

  useEffect(() => {
    setNoteText(selectionFeatureInfo?.notesList[activeQuoteIndex] || "");
  }, [selectionFeatureInfo, activeQuoteIndex]);

  const onNoteChange = (e) => {
    setNoteText(e.target.value);
    if (pulseFeatureInfoNote) {
      togglePulseFeatureInfoNote(false);
    }
  };

  const onNoteSaveClick = () => {
    selectionFeatureInfo.notesList[activeQuoteIndex] = noteText;
    toggleProductNoteEditorVisible(false);
    if (pulseFeatureInfoNote) {
      togglePulseFeatureInfoNote(false);
    }
  };

  return (
    <div className={"product-note" + (productNoteEditorVisible ? " product-note--active" : "")
      + (pulseFeatureInfoNote ? " ui-quantity--pulsing-red" : "")}>
      <textarea name=""
                id=""
                cols="30"
                rows="10"
                className="product-note__textarea ui-textarea"
                placeholder={wizardGroup?.notePlaceholder || intl.formatMessage({id: "quotingTool.featureInfo.addNoteButton"})}
                value={noteText}
                onChange={onNoteChange} />
      <button className="product-note__button ui-button2 ui-button2--green" onClick={onNoteSaveClick}>
        <FormattedMessage id="quotingTool.featureInfo.saveNoteButton"/>
      </button>
    </div>
  )
};

AddProductNoteEditor.propTypes = {
  wizardGroup: PropTypes.shape(wizardGroupInterface),
}

const mapStateToProps = (store) => {
  const {selectionFeatureInfo, productNoteEditorVisible, pulseFeatureInfoNote} = store.selectionState;
  return {
    selectionFeatureInfo,
    productNoteEditorVisible,
    activeQuoteIndex: store.quotesState.activeQuoteIndex,
    pulseFeatureInfoNote,
  };
};

const mapDispatchToProps = {
  toggleProductNoteEditorVisible,
  togglePulseFeatureInfoNote,
};

export default injectIntl(
  connect(mapStateToProps, mapDispatchToProps)(AddProductNoteEditor)
);
